import { createSlice } from "@reduxjs/toolkit"

import { generateSetPropReducer } from "../../../redux/shared/set-setate-prop.reducer.ts"
import { LEAD_STATUSES } from "../../Lead/constants/lead-statuses.ts"
import { logout } from "../../LoginPage/redux/auth.thunks.ts"
import { dashboardSliceName } from "./dashboard.constants.ts"
import { fetchNewLeads, fetchRecentProjects } from "./dashboard.thunks.ts"
import { type DashboardState } from "./dashboard.types.ts"

const initialState: DashboardState = {
  projects: {
    results: [],
    count: 0,
    next: null,
    previous: null
  },
  projectFilters: { page: 1, page_size: 10, q: null },

  leads: {
    results: [],
    count: 0,
    next: null,
    previous: null
  },
  leadFilters: {
    page: 1,
    page_size: 10,
    q: null,
    status: [LEAD_STATUSES?.NEW]?.join(",")
  },

  fetchingProjects: false,
  fetchingLeads: false,
  fetching: false
}

const dashboardSlice = createSlice({
  name: dashboardSliceName,
  initialState,
  reducers: {
    dashboardSetProp: generateSetPropReducer<DashboardState>()
  },
  extraReducers: (builder) => {
    builder
      // fetchRecentProjects
      .addCase(fetchRecentProjects.pending, (state) => {
        state.fetchingProjects = true
      })
      .addCase(fetchRecentProjects.fulfilled, (state, action) => {
        state.fetchingProjects = false
        state.projects = action.payload
      })
      .addCase(fetchRecentProjects.rejected, (state) => {
        state.fetchingProjects = false
        state.projects = initialState.projects
      })

      // fetchNewLeads
      .addCase(fetchNewLeads.pending, (state) => {
        state.fetchingLeads = true
      })
      .addCase(fetchNewLeads.fulfilled, (state, action) => {
        state.fetchingLeads = false
        state.leads = action.payload
      })
      .addCase(fetchNewLeads.rejected, (state) => {
        state.fetchingLeads = false
        state.leads = initialState.leads
      })

      .addCase(logout.fulfilled, () => {
        console.log("dashboard logout")
        return initialState
      })
  }
})

export const { dashboardSetProp } = dashboardSlice.actions

export default dashboardSlice
